import { render, staticRenderFns } from "./GameRules.vue?vue&type=template&id=4f638384&scoped=true"
import script from "./GameRules.vue?vue&type=script&lang=js"
export * from "./GameRules.vue?vue&type=script&lang=js"
import style0 from "./GameRules.vue?vue&type=style&index=0&id=4f638384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f638384",
  null
  
)

export default component.exports